import { useContext } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { ChannelContext, ConfigContext } from '../../context';
import { ConfigDisruptionWidget } from './Disruption';
import { ConfigEventsCalendarWidget } from './EventsCalendar';
import { ConfigExternalLinksWidget } from './ExternalLinks';
import { ConfigFeaturedCardsWidget } from './FeaturedCards';
import { ConfigLatestStoryCardsWidget } from './LatestsStoryCards';
import { ConfigUpcomingEventsWidget } from './UpcomingEvents';

export enum WidgetType {
  EXTERNAL_TAGS_LIST = 'EXTERNAL_TAGS_LIST',
  LATEST_STORY_CARDS = 'LATEST_STORY_CARDS',
  EXTERNAL_LINKS = 'EXTERNAL_LINKS',
  FEATURED_CARDS = 'FEATURED_CARDS',
  DISRUPTION = 'DISRUPTION',
  UPCOMING_EVENTS = 'UPCOMING_EVENTS',
  EVENTS_CALENDAR = 'EVENTS_CALENDAR',
}

export type Widget =
  | { type: WidgetType.LATEST_STORY_CARDS; config: ConfigLatestStoryCardsWidget }
  | { type: WidgetType.EXTERNAL_LINKS; config: ConfigExternalLinksWidget }
  | { type: WidgetType.FEATURED_CARDS; config: ConfigFeaturedCardsWidget }
  | { type: WidgetType.DISRUPTION; config: ConfigDisruptionWidget }
  | { type: WidgetType.UPCOMING_EVENTS; config: ConfigUpcomingEventsWidget }
  | { type: WidgetType.EVENTS_CALENDAR; config?: ConfigEventsCalendarWidget }
  | { type: WidgetType.EXTERNAL_TAGS_LIST };

export const useRightSideWidgets = (): Widget[] => {
  const { id: channelId } = useContext(ChannelContext).channel;

  const {
    organisationWidgets = [],
    channelWidgets = [],
    storyWidgets = [],
  } = {
    ...useContext(ConfigContext).config.elements.rightSideWidgets,
  };

  const { pathname } = useLocation();

  const storyId = Number(useParams().storyId);

  const storyEntry = storyWidgets.find(({ id }) => id === storyId);

  if (storyId && storyEntry) {
    return storyEntry.widgets;
  }

  const channelEntry = channelWidgets.find(({ id }) => id === channelId);

  const tabEntry = channelEntry?.tabs?.find(
    ({ name }) => name === (pathname.split('/')[1] || 'newsFeed')
  );

  if (tabEntry) {
    return tabEntry.widgets;
  }

  if (channelEntry) {
    return channelEntry.default;
  }

  return organisationWidgets;
};
